import Image1 from "../../images/image1.jpg";
import Image2 from "../../images/image2.jpg";
import {
  InfoContainer,
  InfoH1,
  InfoH3,
  InfoP1,
  InfoP2,
  InfoP3,
  InfoP4,
  InfoContent,
  InfoImg,
} from "./InfoSectionElements";

const InfoSection = ({ id }) => {
  return (
    <>
      <InfoContainer id={id}>
        <InfoH1>O nas</InfoH1>
        <InfoH3>
          Witamy Państwa na stronie firmy „ETS” ,jesteśmy producentem daszków i
          zapinek do czapek.
        </InfoH3>
        <InfoContent imgStart={false}>
          <InfoP1>
            Firma istnieje od 1983r. Zajmujemy się produkcją daszków i
            regulatorów (zapinek) do czapek. Współpracujemy z wieloma firmami
            czapniczymi. Daszki wycinany z taśmy z tworzywa spienionego, którą
            sami produkujemy. Dzięki temu mamy możliwość wykonania daszków o
            różnej grubości, tj. od 1,2 mm do 2,2mm. Taśmy produkujemy w
            kolorach: białym i czarnym.Na życzenie daszki mogą być profilowane.
            Wykonujemy nowe wzory wg. projektu Klienta.
          </InfoP1>
          <InfoP2>
            <InfoImg src={Image1} type="image/jpg" />
          </InfoP2>
          <InfoP3>
            <InfoImg src={Image2} type="image/jpg" />
          </InfoP3>
          <InfoP4>
            Dodatkowo w naszej ofercie mamy również szeroki wybór kolorów
            regulatorów (zapinek) do czapek. Celem łatwiejszego wyszukiwania
            wzorów daszków podzieliliśmy je na kilka grup wg. rodzajów czapek.
            Aby pobrać wzór daszka należy kliknąć na zdjęcie.
          </InfoP4>
        </InfoContent>
      </InfoContainer>
    </>
  );
};

export default InfoSection;
